import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Calendar } from 'lucide-react';
export function StickyReservation() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show button after scrolling past the hero section (approx 600px)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-131">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 50
    }} className="fixed bottom-6 right-6 z-50 md:bottom-10 md:right-10" data-id="element-132">
          <a href="https://book.weibook.co/ma-barber-studio" target="_blank" rel="noopener noreferrer" className="bg-gold-500 hover:bg-gold-400 text-charcoal-900 shadow-[0_4px_20px_rgba(0,0,0,0.5)] flex items-center gap-2 px-6 py-4 rounded-full font-bold uppercase tracking-wider text-sm transition-transform hover:scale-105" data-id="element-133">
            <Calendar size={18} data-id="element-134" />
            <span className="hidden sm:inline" data-id="element-135">Reservar Cita</span>
            <span className="sm:hidden" data-id="element-136">Reservar</span>
          </a>
        </motion.div>}
    </AnimatePresence>;
}